module.exports = __webpack_public_path__ + "5d5d494bbe380af41e118e39078f06e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/gonglue/gonglue-bg.jpg
// module id = 1111
// module chunks = 0